import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInsured, IPassportData, IAccidentState } from '../types';

const initialState: IAccidentState = {
  insureds: [], /// застрахованные
  period: null, /// Срок страхования
  coverage: null, /// сумма
  begin_date: null, /// дата начала договора
  sport: null, /// спортивный риск
  clientId: null, /// id клиента
  territory: null, /// териттория
  premium: null,
  productId: 0, /// id продукта для оплаты
  phone: '',
  insuredCount: null,
  insuredData: null,
  insuredsData: [],
  transferType: '',
  isAgent: false,
};

const accidentSlice = createSlice({
  name: 'accident',
  initialState,
  reducers: {
    reset: () => initialState,

    setIsAgent: (
      state: Draft<IAccidentState>,
      action: PayloadAction<boolean>
    ) => {
      state.isAgent = action.payload;
    },

    addInsureds: (
      state: Draft<IAccidentState>,
      action: PayloadAction<number[]>
    ) => {
      state.insureds = action.payload;
    },

    addPhoneNumber: (
      state: Draft<IAccidentState>,
      action: PayloadAction<string>
    ) => {
      state.phone = action.payload;
    },

    addPeriod: (
      state: Draft<IAccidentState>,
      action: PayloadAction<number>
    ) => {
      state.period = action.payload;
    },

    addInsuredCount: (
      state: Draft<IAccidentState>,
      action: PayloadAction<number>
    ) => {
      state.insuredCount = action.payload;
    },

    addCoverage: (
      state: Draft<IAccidentState>,
      action: PayloadAction<number>
    ) => {
      state.coverage = action.payload;
    },

    addBeginDate: (
      state: Draft<IAccidentState>,
      action: PayloadAction<string | number>
    ) => {
      state.begin_date = action.payload;
    },

    addSport: (
      state: Draft<IAccidentState>,
      action: PayloadAction<boolean>
    ) => {
      state.sport = action.payload;
    },

    addTerritory: (
      state: Draft<IAccidentState>,
      action: PayloadAction<{
        name: string;
        value: number;
      }>
    ) => {
      state.territory = action.payload;
    },

    addPremium: (
      state: Draft<IAccidentState>,
      action: PayloadAction<number>
    ) => {
      state.premium = action.payload;
    },

    addProductId: (
      state: Draft<IAccidentState>,
      action: PayloadAction<number>
    ) => {
      state.productId = action.payload;
    },

    addTransferType: (
      state: Draft<IAccidentState>,
      action: PayloadAction<string>
    ) => {
      state.transferType = action.payload;
    },

    secondStepData: (
      state: Draft<IAccidentState>,
      action: PayloadAction<{
        insuredData: IInsured;
        insuredsData: IInsured[];
      }>
    ) => {
      state.insuredData = action.payload.insuredData;
      state.insuredsData = action.payload.insuredsData;
    },
  },
});

export const {
  setIsAgent,
  addPhoneNumber,
  addProductId,
  addInsureds,
  addPeriod,
  addCoverage,
  addBeginDate,
  addSport,
  addTerritory,
  addPremium,
  addInsuredCount,
  secondStepData,
  addTransferType,
} = accidentSlice.actions;
export default accidentSlice.reducer;
